export class ResultAR {
    constructor(
        public tomas: any[],
        public valvulas: any[]
    ) {}
}
